import React from 'react'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'

import TextImageRow from '@/components/sections/TextImageRow'
import { Section } from '@/components/layout'
import trackReceiptsImg from '@/assets/features-potential/track-receipts.jpg'
import id2Img from '@/assets/tax-prep/id2-small.png'
import transactionStreamImg from '@/assets/transaction-streaming/transaction-stream.png'
import organiseFilesImg from '@/assets/features-potential/organise-files.jpg'

export default function FeatureRows({ additionalFeatures = [] }) {
  const { formatMessage } = useIntl()

  return (
    <Section paddingBottom={0} paddingTop={0}>
      <TextImageRow
        image={trackReceiptsImg}
        text={formatMessage({ id: 'featureRows.trackReceipts.text' })}
        title={formatMessage({ id: 'featureRows.trackReceipts.title' })}
      />

      <TextImageRow
        image={id2Img}
        reverse
        text={formatMessage({ id: 'featureRows.dataExtraction.text' })}
        title={formatMessage({ id: 'featureRows.dataExtraction.title' })}
      />

      <TextImageRow
        image={transactionStreamImg}
        text={formatMessage({ id: 'featureRows.dataVerification.text' })}
        title={formatMessage({ id: 'featureRows.dataVerification.title' })}
      />

      <TextImageRow
        image={organiseFilesImg}
        reverse
        text={formatMessage({ id: 'featureRows.organizeFiles.text' })}
        title={formatMessage({ id: 'featureRows.organizeFiles.title' })}
      />

      {additionalFeatures.map(({ image, textId, title }, i) => (
        <TextImageRow
          key={textId}
          image={image}
          reverse={i % 2 !== 0}
          text={formatMessage({ id: textId })}
          title={title}
        />
      ))}
    </Section>
  )
}

FeatureRows.propTypes = {
  additionalFeatures: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      textId: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    }),
  ),
}
